import getEnvironment from './getEnvironment';

export * from './getEnvironment';

export default getEnvironment;
